import * as Sentry from "@sentry/react";
import cloneDeep from 'lodash/cloneDeep';

function setTagsForScope(tagsObj, scope) {
  try {
    if (tagsObj && Object.prototype.toString.call(tagsObj) === '[object Object]') {
      Object(tagsObj).keys.forEach((k) => {
        scope.setTag(k, tagsObj[k]);
      });
    }
  } catch (error) {
    console.log('ERROR setting tags', error.message);
    console.log('SETTAGS Input', tagsObj);
  }

  return scope;
}

function handleMessage(level, data, tagsObj) {
  try {
    if (process.env.REACT_APP_LOG_LEVEL === 'debug') {
      console.log(`${level.toUpperCase()}: `, data);
    }

    if (!data) {
      return;
    }

    if (process.env.REACT_APP_SENTRY_ENABLED) {
      if (data instanceof Error) {
        Sentry.withScope((scope) => {
          scope = setTagsForScope(tagsObj, scope);
          scope.setLevel(level);
          Sentry.captureException(data);
        });
        return;
      }

      let msg = cloneDeep(data);
      if (msg === Object(msg)) {
        msg = JSON.stringify(msg);
      } else {
        msg = `${msg}`;
      }

      Sentry.withScope((scope) => {
        scope = setTagsForScope(tagsObj, scope);
        scope.setLevel(level);
        Sentry.captureMessage(msg);
      });
    }
  } catch (error) {
    console.log('ERROR in logger', error);
    console.log('LOGGER input', level, data);
  }
}

export function initLogger() {
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_SENTRY_ENABLED) {
    try {
      Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DNS,
        environment: 'production',
      });
    } catch (error) {
      console.log(`Could not initialise Sentry ${error.message}`);
    }
  }
}

export const logger = {
  debug: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage('debug', data, tagsObj);
    }, 0);
  },
  info: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage('info', data, tagsObj);
    }, 0);
  },
  warning: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage('warning', data, tagsObj);
    }, 0);
  },
  error: (data, tagsObj) => {
    setTimeout(() => {
      handleMessage('error', data, tagsObj);
    }, 0);
  }
}

export async function captureError(cb) {
  try {
    return await cb();
  } catch (error) {
    logger.error(error);
    throw error;
  }
}
